module.exports = __webpack_public_path__ + "static/media/logo_branca.a130455f.png";